import { ApiUtility } from "./ApiUtility";

class QuoteService {
  
  route = "/posts";
  divinequotesRoute = "/api/Quotes";
  categoryRoute = "/api/settings/filters?lang=";


  getFilters = (lang: string, productFor: string) => {
    return ApiUtility.get(
      this.categoryRoute + lang + "&productFor=" + productFor
    );
  };

  // getDivineQuotesId(id: string) {
  //   return ApiUtility.get(
  //     this.divinequotesRoute + id + "?lang=" + localStorage.getItem("lan")
  //   );
  // }

   getDivineQuotesId(id: string) {
    // id may be a Mongo ObjectId or the public quote number (e.g. "2183").
    const separator = this.divinequotesRoute.endsWith("/") ? "" : "/";
    return ApiUtility.get(
      this.divinequotesRoute + separator + id + "?lang=" + localStorage.getItem("lan")
    );
  }

  // Helmet/OG only: pageTitle, pageDescription, og*, altText.
  // Same identifier as getDivineQuotesId (Mongo id or public quote number).
  getQuoteSeo = (id: string) => {
    const separator = this.divinequotesRoute.endsWith("/") ? "" : "/";
    return ApiUtility.get(
      this.divinequotesRoute +
        separator +
        id +
        "/SEO?lang=" +
        localStorage.getItem("lan")
    );
  };

  // sort: "4" = ascending date, "5" = descending date (same values as the list dropdown).
  // Empty sort is omitted so Home / mobile / related-quote callers keep the API default order.
  getDivineQuotes = (sort: string, start: number, length: number) => {
    let url =
      this.divinequotesRoute +
      "/?search=&start=" +
      start +
      "&length=" +
      length;
    if (sort) {
      url += "&sort=" + sort;
    }
    return ApiUtility.get(url);
  };
}
export default new QuoteService();